module.exports = __webpack_public_path__ + "70e6f2b6c6c741b8d123f886cc4b9844.png";